export default [
    {
        path: "recharge/account",
        name: "rechargeAccount",
        component: () => import(/* webpackChunkName: "recharge" */ "@/views/recharge/account"),
    },
    {
        path: "recharge/record",
        name: "rechargeRecord",
        component: () => import(/* webpackChunkName: "recharge" */ "@/views/recharge/record"),
    },
    {
        path: "recharge/freeze",
        name: "rechargeFreeze",
        component: () => import(/* webpackChunkName: "recharge" */ "@/views/recharge/freeze"),
    }
]


